import { datetime } from '@codegrade/utils';
import { TenantsStore } from '@/store';
import { Search } from '@/utils/search';
import { TenantPrice } from './price';
// eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
export class Tenant {
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    constructor(id, name, ssoProviderId, _logoDefaultUrl, _logoDarkUrl, abbreviatedName, orderCategory, price, _contractStart, netloc) {
        this.id = id;
        this.name = name;
        this.ssoProviderId = ssoProviderId;
        this._logoDefaultUrl = _logoDefaultUrl;
        this._logoDarkUrl = _logoDarkUrl;
        this.abbreviatedName = abbreviatedName;
        this.orderCategory = orderCategory;
        this.price = price;
        this._contractStart = _contractStart;
        this.netloc = netloc;
    }
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    static fromServerData(data) {
        return new Tenant(data.id, data.name, data.ssoProviderId, data.logoDefaultUrl, data.logoDarkUrl, data.abbreviatedName, data.orderCategory, data.price.map(price => new TenantPrice(price)), data.contractStart, data.netloc);
    }
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    get contractStart() {
        return this._contractStart.orDefaultLazy(() => new datetime.DateWithoutTime(1970, 9, 1));
    }
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    getUrl(darkMode = false) {
        return darkMode ? this._logoDarkUrl : this._logoDefaultUrl;
    }
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    get statistics() {
        return TenantsStore.getStatistics()(this);
    }
    // eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
    update(changed) {
        return new Tenant(this.id, this.name, this.ssoProviderId, this._logoDefaultUrl, this._logoDarkUrl, this.abbreviatedName, this.orderCategory, changed.price ?? this.price, this._contractStart, this.netloc);
    }
}
// eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
Tenant.Searcher = new Search(['name', 'abbreviatedName']);
// eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
export class TenantStatistics {
    /**
     * @param studentAmount Map from end of academic year to the amount of students in that period.
     * @param submmissionAmount Map from end of academic year to the amount of submissions in that period.
     * @param amountSubsLastWeek The number of submission received in the last week.
     * @param courseAmounts The number of courses. Contains total and active courses.
     */
    constructor(studentAmount, submmissionAmount, amountSubsLastWeek, courseAmounts) {
        this.studentAmount = studentAmount;
        this.submmissionAmount = submmissionAmount;
        this.amountSubsLastWeek = amountSubsLastWeek;
        this.courseAmounts = courseAmounts;
    }
    /**
     * Constructs an instance of the tenant statistics object from api data.
     *
     * @param data The api data for the tenant statistics.
     * @returns The tenant statistics object constructed from api data.
     */
    static fromServerData(data) {
        return new TenantStatistics(new Map(Object.entries(data.studentAmounts).map(([key, value]) => [
            parseInt(key, 10),
            value,
        ])), new Map(Object.entries(data.submissionAmounts).map(([key, value]) => [
            parseInt(key, 10),
            value,
        ])), data.amountSubmissionsLastWeek, data.courseAmounts);
    }
}
